/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import { Helmet } from "react-helmet-async";
import { makeStyles } from "@material-ui/core/styles";
import InshaHeader from "./InshaHeader";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import InshaFooter from "./InshaFooter";
import InshaHeaderLink from "./InshaHeaderLink";
// import SectionDescription from "views/AboutUsPage/Sections/SectionDescription.js";
import ReturnDescription from "views/InshaBanglesPage/Section/ReturnDescription";
// import SectionTeam from "views/AboutUsPage/Sections/SectionTeam.js";
// import SectionOffice from "views/AboutUsPage/Sections/SectionOffice.js";

import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.js";
import aboutUsStyl from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

const useStyles = makeStyles(aboutUsStyle);
const useStyle = makeStyles(aboutUsStyl);

export default function ReturnPolicy() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  const classe = useStyle();

  const currentUrl = "https://indianbangles.in/return-policy";
  const seoTitle = "Return Policy | INDIAN BANGLES";
  const seoDescription =
    "Read the Return Policy of INDIAN BANGLES for information about eligible returns, damaged products, design mismatch cases, and return support.";
  const seoKeywords =
    "INDIAN BANGLES return policy, jewellery return policy, bangles return policy, imitation jewellery returns, damaged product return policy";
  const ogImage = "https://indianbangles.in/imgstore/original_logo/IndianBanglesImgLogo.png";

  const returnSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Return Policy",
    url: currentUrl,
    description: seoDescription,
    publisher: {
      "@type": "Organization",
      name: "INDIAN BANGLES",
      logo: {
        "@type": "ImageObject",
        url: ogImage,
      },
    },
  };

  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={currentUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="INDIAN BANGLES" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={ogImage} />

        <script type="application/ld+json">
          {JSON.stringify(returnSchema)}
        </script>
      </Helmet>
      <InshaHeader
         brand="INSHA BANGLES PRIVATE LIMITED"
        links={<InshaHeaderLink dropdownHoverColor="dark" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 300,
          color: "dark",
        }}
      />
      <Parallax
        image={require("assets/img/Return-Policy.jpg").default}
        filter="dark"
        small
      >
        <div className={classe.container}>
          <GridContainer justify="center">
            <GridItem
              md={10}
              sm={10}
              className={classNames(
                classe.mlAuto,
                classe.mrAuto,
                classe.textCenter
              )}
            >
              <h1 style={{ color: "#fff", fontFamily: "Tahoma", fontWeight: "bold" }}>Return Policy</h1>
              <h4 style={{ color: "#fff" }}>
                Your satisfaction important to us...
              </h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <ReturnDescription />
          {/* <SectionTeam /> */}
          {/* <SectionOffice /> */}
          <br />
        </div>
      </div>
      <br />
      <br />
      <InshaFooter />
    </div>
  );
}